/**
 * @fileoverview
 * Updates to the new Grid component to mimic the legacy Grid’s layout behavior.
 * For more information about the legacy grid migration see: https://mui.com/material-ui/migration/upgrade-to-grid-v2/
 */

import MuiGrid from '@mui/material/Grid';

/**
 * Grid wrapper that mimics the legacy Grid’s layout behavior.
 * @param {import('@mui/material/Grid').GridProps} props
 * @returns {JSX.Element}
 */
export default function Grid({
    sx, container, children, ...rest
}) {
    // if legacy grid has a container prop then it will set the width to 100%
    // Additional changes like restoring negative margins and legacy grid size props
    // don't seem necessary
    const defaultSx = container ? { width: '100%', minWidth: 'unset' } : { flexFlow: 'wrap' };
    return (
        <MuiGrid
            {...rest}
            container={container}
            sx={[defaultSx, ...(Array.isArray(sx) ? sx : [sx])]}
        >
            {children}
        </MuiGrid>
    );
}
